import * as React from 'react';
import { Link } from 'react-router-dom';
import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';
import TextField from '@material-ui/core/TextField';
import Typography from '@material-ui/core/Typography';

export declare type LoginGridSubmitEventHandler = (userName: string, password: string) => void;

export interface LoginGridProps {
  onSubmit: LoginGridSubmitEventHandler,
}
export function LoginGrid(props: LoginGridProps) {
  const [userName, setUserName] = React.useState('');
  const [password, setPassword] = React.useState('');

  return (
    <Grid container>
      <Grid item xs={12} component={Typography} variant='h6'>Applicant Login</Grid>
      <Grid item xs={12}>
        <Button component={Link} variant="contained" color="inherit" to='/create-account'>Create an Account</Button>
      </Grid>
      <Grid item xs={12}>
        <TextField
          required
          label='Email'
          value={userName}
          onChange={
            (ev) => setUserName(ev.target.value)
          }
        />
      </Grid>
      <Grid item xs={12}>
        <TextField
          required
          type='password'
          label='Password'
          value={password}
          onChange={
            (ev) => setPassword(ev.target.value)
          }
        />
      </Grid>
      <Grid item>
        <Button
          variant='contained'
          color='primary'
          onClick={
            (ev) => {
              ev.preventDefault();
              props.onSubmit(userName, password);
              setPassword('');
            }
          }
        >Login</Button>
      </Grid>
      <Grid item>
        <Button
          component={Link}
          variant='contained'
          color='inherit'
          to='/reset-password'
        >Reset Password</Button>
      </Grid>
    </Grid>
  );
}
